import Api from './Api';

const END_POINT = 'imeis';

export default {
    searchImei(imei_number) {
        return Api.get(`${END_POINT}/${imei_number}`);
    }
}